// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3HGtu","header":"MergedInvoice_header__3XQwU"};